var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_42659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.319 6.56248H31.901V5.46871C31.901 4.86413 31.3915 4.37494 30.7617 4.37494H26.2044C25.5746 4.37494 25.065 4.86413 25.065 5.46871V6.56248H11.3932V5.46871C11.3932 4.86413 10.8837 4.37494 10.2539 4.37494H5.69658C5.06681 4.37494 4.55724 4.86413 4.55724 5.46871V6.56248H1.13934C0.509569 6.56248 0 7.05167 0 7.65625V29.5313C0 30.1358 0.509569 30.625 1.13934 30.625H35.319C35.9487 30.625 36.4583 30.1358 36.4583 29.5313V7.65625C36.4583 7.05167 35.9488 6.56248 35.319 6.56248ZM34.1797 28.4375H2.27862V8.74995H34.1796V28.4375H34.1797Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83593 17.5H9.11455V15.3125H11.3932V13.125H9.11455V10.9376H6.83593V13.125H4.55731V15.3125H6.83593V17.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0651 13.125H31.901V15.3124H25.0651V13.125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_42659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4583,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.54f556ee36f1245322833581930083d9.svg";
export { ForwardRef as ReactComponent };